import { number_from_query, str_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { onMounted, ref, watch } from "vue";
import { toast } from "vue3-toastify";
import type { cmd } from ".";
import type { action } from "../ExplorerV2";
import { use_action } from "../ExplorerV2/useAction";

export const use_cmd = defineStore("cmd", () => {
  const selected_cmd = ref<{ action: action; result: cmd } | null>(null);
  const loading = ref<{
    [key: string]: boolean;
  }>({
    get_cmds: false,
    get_cmd_info: false,
  });
  const action_store = use_action();

  const get_cmds = async () => {
    return action_store.get_action_history({
      page: number_from_query("page", 1),
      size: number_from_query("size", 24),
      keyword: str_from_query("keyword"),
      type: "system_cmd",
    });
  };

  const create_cmd = (cmd: string) => {
    action_store.create_action({
      type: "system_cmd",
      args: cmd,
    });
  };

  const get_cmd_info = async (action_id: string) => {
    loading.value.get_cmd_info = true;

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `/api/v1/view/cmd/${action_id}`,
    };

    axios_instance
      .request<{
        data: {
          action: action;
          result: cmd;
        } | null;
      }>(config)
      .then((response) => {
        selected_cmd.value = response.data.data;
      })
      .catch((error) => {
        selected_cmd.value = null;
        toast.error(error);
      })
      .finally(() => {
        loading.value.get_cmd_info = false;
      });
  };

  onMounted(() => {
    get_cmds();
  });

  watch(
    () => [router.currentRoute.value.query],
    () => {
      if (router.currentRoute.value.name !== "ClientCommand") return;
      get_cmds();
    },
  );

  return {
    selected_cmd,
    loading,
    create_cmd,
    get_cmd_info,
  };
});
